import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import "./keyword.css";

export default function KeywordController({
  loading,
  allkeys,
  selectedkeys,
  search,
  _callback,
  _input_callback,
}) {
  const alloptions = allkeys
    ? allkeys.map((item, index) => {
        return { value: item.key, key: item.id };
      })
    : [];
  const selected_keys = selectedkeys?.map((item, index) => {
    if (item?.key) return { value: item?.key, key: item.id };
    else return item;
  });

  const handleSubmit = (e) => {
    const checkValue = (obj) => obj.value.includes(e);

    if (e.key === "Enter" && !alloptions.some(checkValue)) {

      _input_callback(e);
    } else {
      search(e);
    }
  };
  return (
    <div className="autocomplete">
      <Autocomplete
        loading={loading}
        defaultValue={selected_keys}
        multiple
        autoHighlight
        id="tags-standard"
        filterSelectedOptions
        noOptionsText={
          <div className="d-flex align-items-center justify-content-between mt-2">
            <span className="fw-bold">
              Keyword was not found, You can create a new one
            </span>
          </div>
        }
        options={allkeys ? alloptions : []}
        getOptionLabel={(option) => option.value}
        // shu bir qator kod filterni hal qildi
        isOptionEqualToValue={(option, value) => option?.key === value?.key}
        style={{ width: "100%", borderRadius: "100px !important", padding: 0 }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.key}>
              {option.value}
            </li>
          );
        }}
        ChipProps={{
          style: {
            backgroundColor: "var(--second-color)",
            color: "var(--main-color)",
            fontWeight: "800",
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            color="primary"
            variant="outlined"
            // onKeyDown={(e) => handleSubmit(e)}
          />
        )}
        onChange={(e, target) => _callback(target)}
        onInputChange={(e) => {
          handleSubmit(e.target.value);
        }}
      />
    </div>
  );
}
